module.exports = __webpack_public_path__ + "023ccbf0d08c2e8df718c476230c9fec.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/owl-item-types/bookshelves.png
// module id = 547
// module chunks = 0